import * as S from '@effect/schema/Schema';

export const ModularTemplateListSummary = S.Struct({
    id: S.String,
});

export type ModularTemplateListSummary = S.Schema.Type<typeof ModularTemplateListSummary>;

export const ModularTemplateListSummaries = S.Array(ModularTemplateListSummary);
export type ModularTemplateListSummaries = S.Schema.Type<typeof ModularTemplateListSummaries>;

export const ModularTemplateListResponse = S.Struct({
    modularTemplates: ModularTemplateListSummaries,
});
export type ModularTemplateListResponse = S.Schema.Type<typeof ModularTemplateListResponse>;

export const ModuleType = S.Literal(
    'connecting-corner',
    'middle',
    'ottoman',
    'left-end',
    'right-end',
    'left-end-chaise',
    'right-end-chaise',
);
export const Module = S.Struct({
    groupingCode: S.String,
    // Particle schematic/layout data. TODO: Move this to particle params or schematics.
    bounds: S.Struct({
        min: S.Struct({ x: S.Number, y: S.Number, z: S.Number }),
        max: S.Struct({ x: S.Number, y: S.Number, z: S.Number }),
        rightHanded: S.optional(S.Literal(true)),
    }),
});
export const Ruleset = S.Literal('standard', 'relaxed', 'freeform');
export type Ruleset = S.Schema.Type<typeof Ruleset>;

export const RULESETS = Ruleset.literals;

export const BuildRule = S.Literal(
    'validateNoAdjacentCorners',
    'validateMax2Corners',
    'validateMax3Corners',
    'validateEnds',
    'validateCornersAsEnds',
    'validateChaiseNotCornerAdjacent',
    'validateEndsWithoutOttoman',
    'validateNoEnclosedCornerSequence',
);
export type BuildRule = S.Schema.Type<typeof BuildRule>;

export const BUILD_RULES = BuildRule.literals;

export const FinalisationRule = S.Literal('validateCornersConnected');
export type FinalisationRule = S.Schema.Type<typeof FinalisationRule>;

export const FINALISATION_RULES = FinalisationRule.literals;

export const ModularTemplate = S.Struct({
    id: S.String,
    furnitureType: S.String,
    ruleset: Ruleset,
    buildRules: S.optional(S.Array(BuildRule)),
    finalisationRules: S.optional(S.Array(FinalisationRule)),
    modules: S.partial(S.Record({ key: ModuleType, value: S.Array(Module) })),
});
export type ModuleType = S.Schema.Type<typeof ModuleType>;
export type Module = S.Schema.Type<typeof Module>;
export type ModularTemplate = S.Schema.Type<typeof ModularTemplate>;

export const decodeModularTemplate = S.decodeUnknownSync(ModularTemplate);
export const decodeModularTemplateListSummaries = S.decodeUnknownSync(ModularTemplateListSummaries);
export const decodeModularTemplateListResponse = S.decodeUnknownSync(ModularTemplateListResponse);
